/* hhr-page.js: hides the phone bar while the closing button is on screen */
(function () {
  var bar = document.querySelector('[data-hhr-bar]'), end = document.querySelector('[data-hhr-end]');
  if (!bar || !end || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (e) { bar.classList.toggle('is-hide', e[0].isIntersecting); }).observe(end);
})();
